// Disponibilités déclarées d'un collaborateur — utilitaires PURS partagés entre la
// fiche d'édition RD (Admin) et l'Assistant de placement (Planning). Aucune de ces
// fonctions n'altère un calcul de planning/paie : elles ne servent qu'au RAPPEL VISUEL.

export const WEEKDAYS_FR = [
  "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche",
];
export const WEEKDAYS_SHORT = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

// getDay() JS : 0 = dimanche … 6 = samedi. Notre convention : 0 = lundi … 6 = dimanche.
export function isoWeekday(iso) {
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  return (d.getDay() + 6) % 7;
}

// Entrée de disponibilité pour une date ISO donnée ("YYYY-MM-DD") — ou null si absente.
export function dispoForDate(dispo, iso) {
  if (!dispo || !dispo.jours) return null;
  const wd = isoWeekday(iso);
  if (wd == null) return null;
  return dispo.jours[String(wd)] || null;
}

// Badge d'affichage : { tone: 'ok'|'partial'|'off'|'none', label }.
export function dispoBadge(entry) {
  if (!entry) return { tone: "none", label: "Dispo non renseignée" };
  if (entry.mode === "journee") return { tone: "ok", label: "Disponible toute la journée" };
  if (entry.mode === "indispo") return { tone: "off", label: "Indisponible ce jour" };
  if (entry.mode === "creneau") return { tone: "partial", label: `Disponible ${entry.debut}–${entry.fin}` };
  return { tone: "none", label: "Dispo non renseignée" };
}

// Vrai si le créneau (debut, fin) choisi DÉBORDE de la disponibilité déclarée.
// Comparaison lexicographique sûre sur des heures "HH:MM" zéro-paddées.
export function creneauOutsideDispo(entry, debut, fin) {
  if (!entry) return false;                 // aucune info → pas d'alerte
  if (entry.mode === "journee") return false;
  if (entry.mode === "indispo") return true;
  if (entry.mode === "creneau") {
    if (!debut || !fin) return false;
    return debut < entry.debut || fin > entry.fin;
  }
  return false;
}

export function emptyDispo() {
  return { note: "", jours: {} };
}
